import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";
import { buildGetUsersQueryKey } from "./useGetUsers";
import { buildGetUserQueryKey } from "./useGetUser";
import { toast } from "@shared/services/toast";

type Props = {
  onSuccess?: () => void;
};

type Params = {
  userId: string;
  name: string;
  timezone?: string;
  countryState: string;
  phoneNumber?: string;
  mlsId: string;
  enabledMlsProviders?: string[] | null;
};

export const useEditUser = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getUsersApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response = await api.userControllerUpdateUser({
        userId: params.userId,
        updatedUserRequestOmitted: {
          name: params.name,
          timezone: params.timezone,
          countryState: params.countryState,
          phoneNumber: params.phoneNumber,
          mlsId: params.mlsId,
          enabledMlsProviders: params.enabledMlsProviders,
        },
      });
      queryClient.invalidateQueries({ queryKey: buildGetUsersQueryKey() });
      queryClient.invalidateQueries({
        queryKey: buildGetUserQueryKey(params.userId),
      });
      onSuccess?.();
      toast.success("User details successfully updated.");
      return response;
    },
    onError: (error, { userId }) => {
      console.error(`Failed to edit user with ID: ${userId}`, error);
    },
  });

  return mutation;
};
